import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageMeta from "../components/PageMeta";

// Page d'atterrissage d'un lien de parrainage (oltodo.com/join?ref=CODE). Le code lui-même est
// déjà capturé dans localStorage par AppContext au tout premier rendu (voir context/AppContext.tsx,
// effet basé sur window.location.search) — cette page n'a donc qu'à proposer les deux chemins.
// Pas de Universal Links configurés : "Ouvrir dans l'app" ne marche que si l'app est déjà
// installée (le schéma personnalisé oltodo:// est intercepté par l'OS) ; sinon rien ne se passe,
// limite connue et assumée (voir plan) — la personne doit trouver l'app elle-même, puis
// "Continuer sur le web" capture quand même le parrainage correctement.
export default function Join() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const ref = searchParams.get("ref") || "";

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, backgroundColor: "#FAFAFA" }}>
      <PageMeta title="Rejoindre OLTODO" />
      <div style={{ width: "100%", maxWidth: 380, textAlign: "center" }}>
        <div style={{ fontSize: 26, fontWeight: 900, marginBottom: 8 }}>OLTODO</div>
        <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 10 }}>Un ami t'invite à rejoindre OLTODO</h1>
        <p style={{ fontSize: 14, color: "#666", marginBottom: 32, lineHeight: 1.5 }}>
          Le réseau social qui te reconnecte à ta ville.
        </p>

        <a
          href={`oltodo://join${ref ? `?ref=${ref}` : ""}`}
          style={{ display: "block", padding: "14px", borderRadius: 12, backgroundColor: "#0a0a0a", color: "white", fontSize: 14.5, fontWeight: 700, textDecoration: "none", marginBottom: 12 }}
        >
          Ouvrir dans l'app
        </a>
        <button
          onClick={() => navigate(`/register${ref ? `?ref=${ref}` : ""}`)}
          style={{ width: "100%", padding: "14px", borderRadius: 12, border: "1.5px solid #E0E0E0", backgroundColor: "white", color: "#0a0a0a", fontSize: 14.5, fontWeight: 700, cursor: "pointer" }}
        >
          Continuer sur le web
        </button>
      </div>
    </div>
  );
}
